import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './coupon.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Coupon } from "model/market/coupon.model";

export interface CouponDetailsProps extends DetailsStateAndDispatchProps<Coupon,'couponBreed' | 'couponType'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const CouponDetails: FC<CouponDetailsProps> = (props) => {
  return (
    <DetailsPage<Coupon,'couponBreed' | 'couponType'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Coupon>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ coupon }: RootState) => ({
  entity: coupon.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(CouponDetails);
